import React from "react";
import HttpService from '../../utils/Http.services';
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
// import ProfileImage from "../../components/partials/ProfileImage";
// import TableViewer from "../../components/TableViewer";
// import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import RemoveModal from "../../modals/RemoveModal";
import { checkTextTranslation, checkTranslation, imageAddress, pathMaker, phoneStandardView, priceStandardView, translate } from "../../utils/useful";
import FilterModal from "../../modals/FilterModal";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import Loader from 'react-loader-spinner'
import Modal from "../../components/Modal";
import { saveAs } from 'file-saver';
// import RemoveConfirmationModal from "../../modals/RemoveConfirmationModal";
import WikiAskModal from "../../modals/WikiAskModal";
import moment from 'jalali-moment'
import Collapsible from "react-collapsible";
import FormViewer from "../../components/FormViewer";
import SelectInput from "../../components/inputs/SelectInput";
import { Link } from "react-router-dom";
import store from "../../stores/storeConfig";
import tableComponents from '../../components/tableComponents'


import LoaderButton from "../../components/LoaderButton";
import TextAreaInput from "../../components/inputs/TextAreaInput";
import { socket } from "../../utils/socket.services";

class AdminListApplet extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    state = {
        data: [],
        status: null,
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        stage: 1,
        limit: 20,

        replyHeaders: [
            // { type: 'TextInput', key: 'title',col: '6',  information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'category', type: 'SelectInput',col: '6',  information: { label: '{{lang}}Category', address: 'getContents', filter: { lng: this.props?.lng, page: 'TicketingCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}category', required: true }, showMain: true },
            { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true, inputClass: 'null' }, showMain: false },
            { key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', placeholder: '{{lang}}Attachments', required: false, inputClass: 'null', }, showMain: false },

        ],
        headd: [
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}type..', required: true, }, showMain: false },
            { key: 'price', type: 'PriceInput', col: '12', information: { label: '{{lang}}price', placeholder: '{{lang}}price..', required: true, }, showMain: false },

        ],
        tab: [
            { key: 'user', title: 'User' },
            { key: 'partner', title: 'Partner' }
        ],
        equicment: [
            { img: '/new/292039.png', title: 'Electric Stacker', des: 'Brand Sugico', model: 'Model SR-12-39-1', year: 'Manufacture Year 2013' },
            // { img: '/new/292039.png', title: 'Electric Stacker', des: 'Brand Sugico', model: 'Model SR-12-39-1', year: 'Manufacture Year 2013' },

        ],
        currentTab: 'User',
        currentHeaderTab: 'User',
        statuselist: [
            { title: 'Pending', value: '0' },
            { title: 'Waiting for answer', value: '2' },
            { title: 'Answerd', value: '3' },
            { title: 'Closed', value: '-1' }

        ],
        ticketingSelect: 0,
        options: [
            // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
            // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
            // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
            // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        ],

        attachmentsHeaders: [
            { key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', placeholder: '{{lang}}Attachments', required: false, page: 'ticketing' }, showMain: false },
        ],
    }


    componentDidMount() {
        this.init()
        this.setState({ width: window.innerWidth })
        window.addEventListener('resize', this.updateWidth)

    }



    componentDidUpdate(prevProps, prevState) {
        if (this.props.page !== prevProps.page && this.props.page?.pageType == 'list') {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
        // console.log('this.props.tickets?.object', this.props.tickets?.object)
        // console.log('prevProps?.tickets?.object', prevProps?.tickets?.object)
        if (JSON.stringify(prevProps?.tickets?.object) != JSON.stringify(this.props.tickets?.object) && Object.values(prevProps?.tickets?.object)?.length < Object.values(this.props.tickets?.object).length) {
            // console.log('*updated')
            this.updateTickets()
        }
        if (prevState.data != this.state.data) {
            // console.log('data is ', this.state.data)
            // this.setState({ currentTab: 'User' })
        }
        if (prevState.currentTab != this.state.currentTab) {
            this.setState({ info: null, currentItem: null, stage: 1, currentIndex: null, oneDataList: [] })
        }
        if (prevState.currentItem != this.state.currentItem) {
            this.setState({ attachments: {}, text: '', currentHeaderTab: 'User' })
        }
    }


    updateTickets = () => {
        //partner == true
        let data = [...this.state.data]
        let oneDataList = this.state.oneDataList
        console.log('dataisssssd', data)
        Object.values(this.props.tickets.object).map((element) => {
            if (this.state.currentTab == 'Partner' && element.ticket.partner) {
                let cIndex
                let found
                data.map((item, index) => {
                    // console.log('item',item)
                    // console.log('element.ticketReply._id',element.ticketReply._id)
                    if (item._id == element.ticket._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    console.log('foundTRUEEE', element.ticket, cIndex)
                    // this.setState({ data })
                    if (oneDataList.length != 0) {
                        let ticketObject = JSON.parse(JSON.stringify(element.ticket))
                        ticketObject.seen.admin = true
                        data.splice(cIndex, 1)
                        data.splice(0, 0, ticketObject)
                        oneDataList.push(element.ticketReply)
                        let obj = { _id: element.ticket._id, admin: true }
                        this.updateSeenTicket(obj)
                    } else {
                        data.splice(cIndex, 1)
                        data.splice(0, 0, element.ticket)
                    }
                }
                else {
                    data.splice(0, 0, element.ticket)
                }
            }
            else if (this.state.currentTab == 'User' && !element.ticket.partner) {
                let cIndex
                let found
                data.map((item, index) => {
                    // console.log('item',item)
                    // console.log('element.ticketReply._id',element.ticketReply._id)
                    if (item._id == element.ticket._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    console.log('foundTRUEEE', element.ticket, cIndex)
                    // this.setState({ data })
                    if (oneDataList.length != 0) {
                        let ticketObject = JSON.parse(JSON.stringify(element.ticket))
                        ticketObject.seen.admin = true
                        data.splice(cIndex, 1)
                        data.splice(0, 0, ticketObject)
                        oneDataList.push(element.ticketReply)
                        this.scrollToBottom()
                        let obj = { _id: element.ticket._id, admin: true }
                        this.updateSeenTicket(obj)
                    } else {
                        data.splice(cIndex, 1)
                        data.splice(0, 0, element.ticket)
                    }
                }
                else {
                    data.splice(0, 0, element.ticket)
                }

            }
            store.dispatch(actions.removeTicket({ id: element.ticketReply._id }))
            // console.log('eeeeelement', element)
            // if(){

            // }
        })
        this.setState({ data, oneDataList })
    }
    scrollToBottom = (smooth) => {
        setTimeout(() => {
            if (this.messagesContainer) {
                this.messagesContainer.scrollTo({ top: (this.messagesContainer.scrollHeight + 100), behavior: smooth ? 'smooth' : 'auto' })
            } else {
                this.scrollToBottom()
            }
        }, 1);
        // this.messagesEndRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    updateSeenTicket = (data, cb, tryTime = 0, time = 0) => {
        // console.log('socketINfo', socket)
        if (socket.connected) {
            socket.emit('updateSeenTicket', data, () => {
                store.dispatch(actions.reduceTicketsCount())
                if (cb)
                    cb()
            })
        } else {
            if (tryTime < 10) {
                setTimeout(() => {
                    this.updateSeenTicket(data, cb, (tryTime + 1), (time + 10))
                }, time * 2);
            }
            else {
                if (cb)
                    cb()
            }
        }
    }
    updateWidth = () => {
        this.setState({ width: window.innerWidth })

    }


    init() {
        if (this.props.page) {
            this.setState({ data: [], currentPage: 0, totalCount: null, filter: null }, () => {
                this.fetchData(true)
            })
        }
    }
    changeTab = (key) => {
        if (this.state.currentHeaderTab != key) {

            this.setState({ isLoadingInfo: true, oneDataList: [] })
            // console.log('this.state.', this.state.info)
            let data = {}
            if (key == 'Partner') {
                data.partner = true
                data.creator = this.state.info.equipmentOwner
                data.equipment = this.state.info.equipment
            }
            else {
                data._id = this.state.currentItem._id
            }
            data.admin = true
            HttpService.request('getOneTicket', data, (fetchResult, fetchError) => {
                this.setState({ isLoadingInfo: false })
                if (fetchError) {
                    return
                }
                // console.log('feychresult0', fetchResult)
                if (fetchResult.info && fetchResult.answers) {

                    let oneDataList = fetchResult.answers
                    // console.log('fetchResultfetchResult', fetchResult)
                    this.setState({ currentHeaderTab: key, oneDataList, info: fetchResult.info }, () => {
                        this.scrollToBottom()
                    })
                    HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
                        if (fetchError) {
                            return
                        }
                        // console.log('fetchResuktic', fetchResult.count)
                        store.dispatch(actions.addTicketsCount(fetchResult.count))
                    })
                }
                else {
                    this.setState({ currentHeaderTab: key, oneDataList: [], info: { equipment: this.state.info.equipment } })
                }
            })
        }

    }

    fetchData = (getCount) => {


        this.setState({ isLoadingData: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage

        body.filter = this.state.filter ?? {}
        if (this.props.page.postBody) {
            body.filter = { ...body.filter, ...this.props.page.postBody }
        }
        // console.log(this.state.filter)

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }

        // console.log(body)
        // console.log('test', page.fetchUrl)
        body.admin = true
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            console.log('aaaaaaaaaaressss', fetchResult)
            for (let i = 0; i < fetchResult.info.length; i++) {
                const element = fetchResult.info[i];
                element.equipment = element.equipmentRental
            }
            this.setState({ isLoadingData: false })
            // console.log(fetchError)
            if (fetchError) {
                console.log('fetchError', fetchError)
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log(fetchResult)
            // this.setState({ data: [] }, () => {
            this.setState({ data: fetchResult.info }, () => {
                // console.log('paris', this.state.data)
            })
            // this.setState({ data: [1,1,1,1,1,1,1,1,1] })

            // })
            store.dispatch(actions.addTicketsCount(fetchResult.unRead))
            // console.log('fetchResult.unRead', fetchResult.unRead)

            if (fetchResult.count != null) {
                // console.log(' fetchResult.countss', fetchResult.count)

                this.setState({ totalCount: fetchResult.count })
            }
        })
    }



    updateStatus = (value, extra) => {


        // this.setState({ isLoadingInfo: true, oneDataList: [] })
        console.log('aaaaaaaaaaaaaa', this.state.info)
        console.log('aaaaaaaaaaaaaa', value)
        console.log('aaaaaaaaaaaaaa', this.props.page)
        let body = this.state.info

        body.status = value
        let page = this.props.page


        HttpServices.request('changeTicketStatus', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingInfo: false })
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            console.log(fetchError)
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccesfully' })
            console.log(fetchResult)
            console.log(fetchError)
            this.setState({ info: fetchResult.info, status: null })

            console.log(fetchError)
            // if (fetchResult) {
            this.modal.hideModal()
            // }
            let data = this.state.data
            data.forEach((element, index) => {
                if (element._id == body._id) {
                    data[index] = fetchResult.info
                }
            });
            this.setState({ data })
            this.fetchData(true)
        })
    }





    fetchOne = (item) => {


        this.setState({ isLoadingInfo: true, oneDataList: [] })
        let body = { _id: item._id }
        let page = this.props.page

        body.admin = true
        HttpServices.request(page.fetchOneUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingInfo: false })
            // console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            console.log(fetchResult)
            this.setState({ oneDataList: [] }, () => {
                this.setState({ info: fetchResult.info, oneDataList: fetchResult.answers }, () => {
                    this.scrollToBottom()
                })
                // this.setState({ data: [1,1,1,1,1,1,1,1,1] })

                HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                    // console.log('fetchResuktic', fetchResult.count)
                    store.dispatch(actions.addTicketsCount(fetchResult.count))
                })
                let data = JSON.parse(JSON.stringify(this.state.data))
                // console.log('data', data)
                // console.log('this.state.info', this.state.info)
                // console.log('fetchResult', fetchResult)
                data.forEach((element, index) => {
                    if (element?._id == this.state.info?._id) {
                        data[index] = fetchResult.info
                    }
                });
                // console.log('dataischanged', data)
                this.setState({ data }, () => {
                    // console.log('daaaaaaaaaaaaaats', this.state.data)
                })
            })

            // if (fetchResult.count != null) {
            //     this.setState({ totalCount: fetchResult.count })
            // }
        })
    }



    postReply = () => {

        // let data = this.form.getForm()
        let data = {}

        if (this.state.text) {
            data.body = this.state.text.trim()
        }
        if (this.state.attachments) {
            console.log('dataaaaaaa attachment', this.state.attachments);
            data['**files'] = this.state.attachments['**files']
        }




        // if (data) {
        if ((data.body && data.body.trim()) || data['**files']) {

            this.setState({ isLoadingPostReply: true, replyData: data })

            let page = this.props.page

            let body = data
            body.ticket = this.state.info._id
            body.equipment = this.state.info.equipment?._id
            body.isAdminReply = true


            HttpServices.request(page.addOneUrl, body, (fetchResult, fetchError) => {
                this.setState({ isLoadingPostReply: false })
                // console.log(fetchError)
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postedFailed', description: fetchError.message })
                    return
                }
                let oneDataList = this.state.oneDataList
                // oneDataList.splice(0, 0, fetchResult.info)
                oneDataList.splice((oneDataList.length), 0, fetchResult.info)


                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccesfully' })
                this.setState({ attachments: {}, text: '', replyData: {}, oneDataList, info: fetchResult.parent, showReply: false }, () => {
                    this.scrollToBottom()
                })
                console.log(fetchResult)


                let data = this.state.data
                data.forEach((element, index) => {
                    if (element._id == this.state.info._id) {
                        data[index] = fetchResult.parent
                    }
                });
                this.setState({ data }, () => {
                    console.log('dss', this.state.data)
                })
                this.fetchData()

            })

        }


    }


    openOne = (item, index) => {

        console.log('first', item, index)
        // return
        this.setState({ stage: 2, info: item, currentItem: item, currentIndex: index, oneDataList: [], ticketingSelect: index }, () => {
            console.log('first', this.state.info)

            this.fetchOne(item)
        })
    }

    closeOne() {
        this.setState({ stage: 1, info: null, currentItem: null, currentIndex: null, oneDataList: [] }, () => {
        })
    }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
            this.closeOne()
        })
    }



    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.info?._id

        console.log('idddddddddddddddddddddd', id)
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
            this.fetchData(true)
            this.closeOne()

        })

    }



    fetchExport = () => {
        // this.setState({ isLoadingRemove: true })
        // let id = this.state.currentItem._id
        HttpServices.request(this.props.page?.extra?.export?.url, {}, (fetchResult, fetchError) => {
            // this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            // console.log(fetchResult)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // let data = this.state.data
            // data.splice(this.state.currentIndex, 1)
            // this.setState({ data })
            // console.log(siteConfig.assetsDomain + fetchResult.info)
            saveAs(siteConfig.assetsDomain + fetchResult.info)

            this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }


    itemAdded = (newItem) => {
        if (newItem) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        }
    }

    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    updateData = (data) => {
        this.setState(data)
    }


    openAddNew = () => {
        if (this.props.page?.addNew) {
            let newPage = this.props.page?.addNew
            if (this.props.page?.addNew.includes('../')) {
                newPage = this.props.route + this.props.page?.addNew.replace('..', '')
            }
            // console.log(newPage)
            this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
        } else {
            this.openEditModal()
        }
    }

    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        console.log(data)
        this.setState({ currentPage: 0, filter: data }, () => {
            this.fetchData(true)
            this.filterModal.modal.hideModal()

        })
    }


    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.type == 'DateInput') {
            if (Array.isArray(value)) {
                value.forEach((element, index) => {
                    value[index] = moment(element).format('jYYYY/jMM/jDD')

                });
            } else {
                value = moment(value).format('jYYYY/jMM/jDD')

            }
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }


    removeFilter = (prop) => {
        let filter = this.state.filter
        delete filter[prop.key]
        // console.log(filter)
        this.setState({ filter }, () => {
            this.fetchData(true)
        })
    }


    openOptions = (prop, index) => {
        // console.log(prop)

        let options = []

        Object.values(this.props.page?.extra).forEach(element => {
            let option = { ...element }
            option.function = this[option.function]
            options.push(option)
        });
        console.log(options)
        // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
        // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
        // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
        // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        // ]

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })

    }

    openExport = () => {
        this.exportModal.showModal()
        this.fetchExport()
        // console.log("TEST")
    }

    askForWikiChanges = (data) => {
        if (!data._id) {
            this.itemModal.postValue()
        } else {
            this.wikiAksModal.modal.showModal()
        }
    }
    submitWikiChanges = (postFilter) => {
        this.itemModal.postValue(postFilter)
        this.wikiAksModal.modal.hideModal()
    }

    getStatusInfo(status) {
        switch (status) {
            case '0':
                return { label: '{{lang}}Pending', color: '#EE5050', icon: '' }
                break;

            case '2':
                return { label: '{{lang}}Waiting for answer', color: '#EE5050', icon: '' }
                break;

            case '3':
                return { label: '{{lang}}Answered', color: '#35A45C', icon: '' }
                break;

            case '-1':
                return { label: '{{lang}}Closed', color: '#789', icon: '' }
                break;

            default:
                return { label: '{{lang}}Pending', color: '#EE5050', icon: '' }
                break;
        }
    }
    handleModal = () => {
        // this.setState({ showChangeStatus: !this.state.showChangeStatus })
        this.modal.showModal()
    }
    Modalinformation = () => {
        // this.setState({ showChangeStatus: !this.state.showChangeStatus })
        this.modalI.showModal()
    }
    changeTicketingTab = (key) => {
        if (key != this.state.currentTab) {
            this.setState({ isLoadingData: true })
            console.log(true)
            // this.setState({ data: [] })
            let body = this.props.page.filter ?? {}
            let page = this.props.page
            body.page = page.key
            body.limit = this.state.limit
            body.skip = this.state.currentPage

            body.filter = this.state.filter ?? {}

            // console.log(this.state.filter)

            for (const [key, value] of Object.entries(body)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }


            body.admin = true
            console.log('body.partner', body.partner)
            if (key == 'Partner') {
                console.log('body.partner', body.partner)
                body.partner = true
                console.log('body.partner', body.partner)
            }
            if (this.props.page.postBody) {
                body.filter = { ...body.filter, ...this.props.page.postBody }
            }
            console.log('body.partner', body)

            HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
                this.setState({ isLoadingData: false })
                // console.log(fetchError)
                if (fetchError) {
                    console.log('fetchError', fetchError)
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                console.log(fetchResult)
                // this.setState({ data: [] }, () => {
                this.setState({ data: fetchResult.info, currentTab: key, }, () => {
                    console.log('paris333', this.state.data)
                })
                // this.setState({ data: [1,1,1,1,1,1,1,1,1] })

                // })
                store.dispatch(actions.addTicketsCount(fetchResult.unRead))
                console.log('fetchResult.unRead', fetchResult.unRead)

                if (fetchResult.count != null) {
                    console.log(' fetchResult.countss', fetchResult.count)

                    this.setState({ totalCount: fetchResult.count })
                }
            })
            // let data = {}
            // if (key == 'Partner') {
            //     data.partner = true
            //     data.creator = this.state.data.equipmentOwner
            //     data.equipment = this.state.data.equipment
            // }
            // else {
            //     data._id = this.state.currentItem._id
            // }
            // data.admin = true
            // HttpService.request('getTickets', data, (fetchResult, fetchError) => {
            //     if (fetchError) {
            //         return
            //     }
            //     if (fetchResult.info && fetchResult.answers) {

            //         let oneDataList = fetchResult.answers
            //         console.log('fetchResultfetchResult', fetchResult)
            //         this.setState({ currentTab: key, oneDataList, info: fetchResult.info })
            //         HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
            //             if (fetchError) {
            //                 return
            //             }
            //             console.log('fetchResuktic', fetchResult.count)
            //             store.dispatch(actions.addTicketsCount(fetchResult.count))
            //         })
            //     }
            //     else {
            //         this.setState({ currentTab: key, oneDataList: [], info: { equipment: this.state.data.equipment } })
            //     }
            // })
        }
    }

    updateInput = (element) => {
        // element.style.height = "5px";
        // console.log(element.scrollHeight)
        element.style.height = 'inherit';
        element.style.height = (element.scrollHeight) + "px";
        this.setState({ text: element.value })
    }


    showAttachments() {
        this.attachments.showModal()
    }

    getFile = () => {
        let attachments = this.attachmentsForm.getForm()
        if (!attachments['**files']) {
            attachments['**files'] = {}
        }
        console.log('attachmentsfirst', attachments)
        this.setState({ attachments }, () => {
            this.attachments.hideModal()
        })
    }
    ConvertToOrder = () => {
        let data = this.ConvertOrder.getForm()
        // console.log('attachmentsfirst', data)
        if (data) {
            data.status = '0'
            data.paymentStatus = '0'
            data.product = this.state.info.equipment._id
            data.customer = this.state.info.creator._id
            // console.log('dataaaaaaaaaaaaaaaaaaaaaa', data, this.state.info)
            HttpService.request('tradingOrdersAdd', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // if (fetchResult.info && fetchResult.answers) {

                //     let oneDataList = fetchResult.answers
                //     console.log('fetchResultfetchResult', fetchResult)
                //     this.setState({ currentTab: key, oneDataList, info: fetchResult.info })
                //     HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
                //         if (fetchError) {
                //             return
                //         }
                //         console.log('fetchResuktic', fetchResult.count)
                //         store.dispatch(actions.addTicketsCount(fetchResult.count))
                //     })
                // }
                // else {
                //     this.setState({ currentTab: key, oneDataList: [], info: { equipment: this.state.info.equipment } })
                // }
            })
        }


    }






    scrollToBottom = (smooth) => {
        console.log("scrollToBottom")
        setTimeout(() => {
            if (this.messagesContainer) {
                this.messagesContainer.scrollTo({ top: (this.messagesContainer.scrollHeight + 100), behavior: smooth ? 'smooth' : 'auto' })
            } else {
                this.scrollToBottom()
            }
        }, 1);
        // this.messagesEndRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }



    render() {
        return (
            <>
                <Configurer
                    settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: false } }}
                    title={checkTextTranslation(this.props.page?.title)}
                    description={checkTextTranslation(this.props.page?.description)}
                    className=""
                    style={{ position: 'sticky', top: 50 }}
                >

                    <div className="p-0" style={{ background: '#fff' }} >
                        <div className="row m-0 p-0" >


                            {(this.state.stage == 1 || this.state.width > 767) && (
                                <>
                                    {/* <div className=" col-md-12 col-lg-3 m-0 h-100" style={{ backgroundColor: '#fafbfc', padding: 0 }}>
                                        {/* <div className="col-12 col-md-5 col-lg-4 mb-5 mt-4 w-100 p-0"> *


                                        <div className=" w-100 sc-1" style={{ backgroundColor: '#fff', padding: 0 }}>


                                            {/* <button onClick={() => this.openFilterModal()} className="flexc px-4 mrd-3 w-100 py-2" style={{ flex: 1, color: '#000', backgroundColor: '#fff', borderRadius: '10px' }}>
                                                <img className=" " src="/images/search.svg" alt="" width="16px" />
                                                <span className="text-small mx-1  text-bold" >Filter</span>
                                            </button>  *
                                            <div className='w-100' style={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 0px 10px 0px', position: 'sticky', top: 0, zIndex: 99 }}>
                                                <div className='px-3 py-1 pb-2 pt-2 w-100' style={{ backgroundColor: '#fff' }}>
                                                    <h1 style={{ fontSize: '15px', fontWeight: 600 }} className=''>{translate("Support Tickets")}</h1>
                                                </div>
                                            </div>



                                            <div className="flexc px-2" style={{}}>
                                                {this.state.filter && Object.values(this.state.filter).map((prop, index) => {
                                                    console.log(prop)
                                                    if ((prop.key != 'location') && (prop.key != 'location1')) {

                                                        return (
                                                            <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                                                <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                                                    <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                                                </button>
                                                                <p className="text-smaller">{checkTranslation(this.filterLabelCreator(prop))}</p>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                                                <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                                                    <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                                                </button>
                                                                <p className="text-smaller">LAT {prop.value.lat} - LNG {prop.value.lng} {prop.value.radius ? (" - Radius " + priceStandardView(prop.value.radius) + ' meters') : ""} </p>
                                                            </div>
                                                        )
                                                    }
                                                }
                                                )}

                                            </div>

                                            <div className="sc-1 w-100" style={{ height: this.state.width > 767 ? 'calc(100vh - 50px)' : '', overflow: this.state.width > 767 ? 'auto' : '', }}>
                                                {console.log('this.state.data', this.state.data)}
                                                {this.state.data.map((item, index) => {
                                                    let status = this.getStatusInfo(item.status)
                                                    return (

                                                        <div className="single-ticket py-2 px-3 flexc w-100  " style={{ cursor: 'pointer' }} onClick={() => this.openOne(item, index)}>
                                                            {/* {console.log('first', item)} *
                                                            <div>
                                                                <div className="ticket-situation flexcc" >
                                                                    <img style={{ width: '20px', height: '20px' }} src={item.status != '-1' ? status.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} />
                                                                </div>
                                                            </div>
                                                            <div className="px-2">
                                                                {/* {console.log('this.state.info?.creator?.name', item)} *
                                                                {/* <p style={{ fontSize: '12px', fontWeight: 500, color: '#555' }} className="">#{item.id} , {checkTranslation(status.label)}</p> *
                                                                <p style={{ fontSize: '12px', fontWeight: 500, color: '#555' }} className="">{item?.creator?.name}</p>
                                                                <p style={{ fontSize: '12px', color: '#000' }} className="">{item.title}</p>

                                                                {/* <p className="ticket-desc">{item.description?.substr(0, 70)}{item.description?.length > 70 ? ' ...' : ''} </p> *
                                                                <p style={{ fontSize: '10px', color: '#999' }} className="">{moment(item.uDate).format("MMM YYYY, DD HH:mm")}</p>
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                                )}
                                            </div>

                                            {!this.state.isLoadingData && (!this.state.data || this.state.data.length == 0) && (
                                                <p className="text-center text-smaller text-bold mt-3">Found Nothing</p>
                                            )}

                                            {this.state.isLoadingData && (
                                                <div className="flexcc w-100 mt-3" style={{ alignItems: 'center' }}>
                                                    <Loader
                                                        type="ThreeDots"
                                                        color="#789"
                                                        height="40"
                                                        width="40"
                                                    />
                                                </div>
                                            )}

                                            <div className="mt-3">
                                                <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                                            </div>
                                        </div>


                                    </div> */}



                                    <div className="col-12 col-md-5 col-lg-3 p-0 m-0" style={{ backgroundColor: 'white', borderRight: '1px solid #e6e6e6', height: this.state.width > 767 ? 'calc(100vh - 116px)' : '', }}>


                                        <div className=" w-100 " style={{ height: this.state.width > 767 ? 'calc(100% - 46px)' : '', borderRadius: '10px' }}>

                                            <div className='w-100 flexcb' style={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 0px 0px 0px', borderBottom: '1px solid #eee' }}>
                                                <div className='container py-2 w-100' style={{ backgroundColor: 'white', borderRadius: '0px 0px 0px 0px' }}>
                                                    <h1 className='m-0' style={{ fontSize: '15px', fontWeight: 600 }} >{translate("Support Tickets")}</h1>
                                                </div>

                                                <div className="flexc pr-2 py-2">

                                                    {Array.isArray(this.props?.page?.tab) && this.props?.page?.tab.map((prop, index) => {
                                                        let notif
                                                        if (this.props.tickets?.count[prop.key] && this.props.tickets?.count[prop.key] != 0) {
                                                            notif = this.props.tickets.count[prop.key]

                                                        }
                                                        return (
                                                            <>
                                                                <div style={{ cursor: 'pointer', position: 'relative', borderBottom: this.state.currentTab == prop.title ? '2px solid #ee5050cc' : '1px solid #fff' }} className='p-1 flexc mr-2' onClick={() => this.changeTicketingTab(prop.title)}>
                                                                    <p className='' style={{ fontSize: '13px', color: '#636363' }}>{prop.title}</p>
                                                                    {(notif) ? (
                                                                        <div className="blur-back flexcc" style={{ position: 'absolute', top: 2, left: '-4%', backgroundColor: '#ee5050cc', borderRadius: "50%", minWidth: 8, minHeight: 8 }}>

                                                                        </div>
                                                                        // <div className="flexcc position-absolute white" style={{ top: 0, left: notif > 1000 ? -20 : 10, backgroundColor: '#ee5050ee', borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>
                                                                        //     <span className='px-1'>{notif}</span>
                                                                        // </div>

                                                                    ) : ''}

                                                                </div>
                                                            </>
                                                        )
                                                    })}

                                                </div>
                                            </div>
                                            {/* {console.log(';;;;;;0', this.state.isLoadingData)} */}
                                            {this.state.isLoadingData ? (

                                                <div className="flexcc w-100 mt-3" style={{ alignItems: 'center' }}>
                                                    <Loader
                                                        type="ThreeDots"
                                                        color="#789"
                                                        height="40"
                                                        width="40"
                                                    />
                                                </div>


                                            ) : (
                                                <div className='sc-1 h-100 pt-0' style={{ overflow: 'auto' }}>
                                                    {/* {console.log('status.label=========', this.state.data)}
                                                    {console.log('status.label=========', this.props.tickets)} */}

                                                    {this.state.data?.map((item, index) => {
                                                        return (
                                                            <div className=" flexc w-100  px-2 py-1" style={{ position: 'relative', borderBottom: '1px solid #f8f8f8', cursor: 'pointer', background: this.state.currentIndex === index && this.state.width > 991 ? '#efefef' : '', }} onClick={() => this.openOne(item, index)}>
                                                                <div>
                                                                    <div className="ticket-situation flexcc" style={{}}>
                                                                        {/* <img style={{ width: '20px,', height: '20px' }} src={item.status != '-1' ? status.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" /> */}
                                                                        <img className=' ' style={{ width: '35px', height: '35px', objectFit: 'cover', borderRadius: '5px', position: 'relative', borderRadius: '50%', position: 'relative' }} src={imageAddress(this.state.data[index].equipment?.image)} />
                                                                        {/* <img className=' ' style={{ width: '35px', height: '35px', objectFit: 'cover', borderRadius: '5px', position: 'relative', borderRadius: '50%', position: 'relative' }} src={contentUrl + 'thumb-' + this.state.data[index].equipment?.image[0]} /> */}
                                                                        {((item.status == '2' || item.status == '0') && !item.seen?.admin) ? (
                                                                            <>
                                                                                {console.log('changedTOOOTURE')}
                                                                                <div className="flexcc position-absolute white" style={{ top: 14, left: 8, backgroundColor: '#ee5050ee', borderRadius: 30, minWidth: 10, height: 10, fontSize: 14 }}>
                                                                                    {/* <span className='px-1' style={{ fontSize: '9px' }}>{this.props.tickets?.count}</span> */}
                                                                                </div>
                                                                            </>
                                                                        ) : ''}
                                                                    </div>
                                                                </div>
                                                                <div className="px-2 py-2">
                                                                    {/* {console.log('yyyyyyyyyyy', item, index, this.state.data)} */}
                                                                    {(this.state.data[index].equipment?.title && this.state.data[index].equipment?.title.length != 0 && this.state.data[index].equipment?.title != null && this.state.data[index].equipment?.title != undefined && this.state.data[index].equipment?.title != '') ? (
                                                                        <div className="flexc">

                                                                            <p className="blogsbox-p2 mt-1" style={{ fontSize: 14, fontWeight: '500' }}>
                                                                                {this.state.data[index].equipment?.title}
                                                                                {/* {item.category.length > 0 && (item.category[item.category.length - 1].parent != null ? item.category[item.category.length - 1].name : item.category.length > 2 ? item.category[1].name : item.category[0].name)} */}
                                                                            </p>

                                                                            {/* {console.log('item?.creator?.name', item?.creator?.name)} */}
                                                                            {/* {item?.creator?.name && (

                                                                                <p className="blogsbox-p2 mt-1" style={{ fontSize: 11, fontWeight: '400' }}>
                                                                                    &nbsp;({item?.creator?.name})
                                                                                </p>
                                                                            )} */}
                                                                        </div>

                                                                    ) : (
                                                                        <div className="">
                                                                            <div>
                                                                                <span className='blogsbox-p2 mt-1' style={{ fontSize: 14, fontWeight: '500' }}>{this.state.data[index].equipment?.year} {this.state.data[index].equipment?.model} {this.state.data[index].equipment?.brand?.name} {this.state.data[index]?.equipment?.category[this.state.data[index].equipment?.category?.length - 1]?.name}</span>
                                                                                {/* <span className='blogsbox-p2 mt-1' style={{ fontSize: 12, fontWeight: '400' }}> /</span>
                                                                                <span className='blogsbox-p2 mt-1' style={{ fontSize: 12, fontWeight: '400' }}> /</span> */}
                                                                            </div>
                                                                            {/* {console.log('this.state.data[index].equipment?', this.state.data[index].equipment.category[this.state.data[index].equipment.category.length - 1]?.name)} */}
                                                                            {/* {item?.creator?.name && (

                                                                                <p className="blogsbox-p2 " style={{ fontSize: 11, fontWeight: '400' }}>
                                                                                    {item?.creator?.name}
                                                                                </p>
                                                                            )} */}
                                                                        </div>
                                                                    )}

                                                                    <p className="blogsbox-p2 mt-1" style={{ fontSize: 11, fontWeight: '400' }}>
                                                                        {item?.creator?.name}
                                                                    </p>
                                                                    <p className='' style={{ fontSize: '12px', color: '#000' }}>{item.title}</p>
                                                                    {/* <p className='' style={{ fontSize: '12px', color: '#000' }}>{item.status}</p> */}

                                                                    {/* <p className="ticket-desc">{item.description?.substr(0, 70)}{item.description?.length > 70 ? ' ...' : ''} </p> */}
                                                                    <p className="mt-1" style={{ fontSize: '10px', color: '#888' }} >{moment(item.uDate).format("MMM YYYY, DD HH:mm")}</p>

                                                                    <div className='flexcc' style={{ position: 'absolute', top: 12, left: 24, margin: 3, padding: '2px', background: '#ffffffcc', borderRadius: 50 }}>
                                                                        <img style={{ width: '14px,', height: '14px' }} src={this.getStatusInfo(item?.status) != '-1' ? this.getStatusInfo(item?.status)?.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" />
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        )
                                                    }
                                                    )}
                                                </div>
                                            )}



                                            {!this.state.isLoadingData && (!this.state.data || this.state.data.length == 0) && (
                                                <p className="text-center text-smaller text-bold mt-3">Found Nothing</p>
                                            )}

                                            {/* {this.state.isLoadingData && (
                                                <div className="flexcc w-100 mt-3" style={{ alignItems: 'center' }}>
                                                    <Loader
                                                        type="ThreeDots"
                                                        color="#789"
                                                        height="40"
                                                        width="40"
                                                    />
                                                </div>
                                            )} */}

                                            <div className="py-2">
                                                <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )}



                            {(this.state.stage == 2 || this.state.width > 767) && (

                                <div className="col-12 col-md-7 col-lg-9 no-scrollbar w-100 " ref={el => this.messagesContainer = el} style={{ height: this.state.width > 767 ? 'calc(100vh - 116px)' : '', overflow: this.state.width > 767 ? 'auto' : '', padding: 0 }}>

                                    {!this.state.info && (

                                        <div className='text-center w-100' style={{ paddingTop: 100 }}>
                                            <img src='/images/faq.png' width={80} alt="" />
                                            <p className="mt-2" style={{ fontWeight: 'bold', fontSize: 20 }}>Ticket Not Selected</p>
                                            <p className='mt-1' style={{ fontSize: 14 }}>Select a ticket to see the information</p>

                                        </div>

                                    )}
                                    {this.state.info && (
                                        <div style={{}} className="row m-0 h-100">
                                            {this.state.isLoadingInfo ? (

                                                <div className="flexcc w-100 mt-3" style={{ alignItems: 'center' }}>
                                                    <Loader
                                                        type="ThreeDots"
                                                        color="#789"
                                                        height="40"
                                                        width="40"
                                                    />
                                                </div>


                                            ) : (
                                                <>

                                                    <div className="p-0 col-md-12 col-lg-8 order-lg-1 order-2 " style={{ borderRight: '1px solid #efefef', borderLeft: '1px solid #efefef', }}>
                                                        <div className='pb-2' style={{ height: 'calc(100% - 58px)' }}>
                                                            <div className='w-100 flexcb' style={{ background: "#fff", position: 'sticky', height: 43, top: 0, borderBottom: '1px solid #eee' }}>
                                                                <div className="flexcb w-100 py-2" >
                                                                    <div className="flexcb">
                                                                        <button className='d-lg-none ml-2' onClick={() => this.setState({ stage: 1 })}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style={{ width: 18 }}>
                                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                                                                            </svg>

                                                                        </button>
                                                                        <div className="flexc w-100 mx-2 " style={{}}>

                                                                            <div className="flexc">
                                                                                <img className="mr-2" style={{ borderRadius: 50, objectFit: "cover", width: 30, height: 30, background: '#fff' }} src={imageAddress(this.state.info?.equipment?.image)} />


                                                                                {(this.state.info?.equipment?.title && this.state.info?.equipment?.title.length != 0 && this.state.info?.equipment?.title != null && this.state.info?.equipment?.title != undefined && this.state.info?.equipment?.title != '') ? (

                                                                                    <p className="flexcc " style={{ color: '#222', fontSize: 15, fontWeight: '500' }}>{this.state.info?.equipment?.title}</p>


                                                                                ) : (
                                                                                    <div className='flexc'>
                                                                                        <a href={"https://antbuildz.com/buy/equipment/" + this.state.info?.equipment?._id}>
                                                                                            <span className='' style={{ color: '#222', fontSize: 15, fontWeight: '500' }}>{this.state.info?.equipment?.year} {this.state.info?.equipment?.model} {this.state.info?.equipment?.brand?.name} {this.state.info?.equipment?.category[this.state.info?.equipment?.category.length - 1]?.name}</span>
                                                                                        </a>
                                                                                        {/* <span className='' style={{ color: '#222', fontSize: 15, fontWeight: '500' }}> /</span>
                                                                                        <span className='' style={{ color: '#222', fontSize: 15, fontWeight: '500' }}> /</span> */}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                        </div>

                                                                    </div>


                                                                </div>
                                                                <div className="d-flex">
                                                                    {this.state.currentTab == 'User' ? (
                                                                        <>
                                                                            {Array.isArray(this.props?.page?.tab) && this.props?.page?.tab.map((prop, index) => {

                                                                                return (
                                                                                    <>
                                                                                        <div style={{ cursor: 'pointer', position: 'relative', borderBottom: this.state.currentHeaderTab == prop.title ? '2px solid #ee5050cc' : '1px solid transparent' }} className='p-1 flexc mr-2' onClick={() => this.changeTab(prop.title)}>
                                                                                            <p className='' style={{ fontSize: '13px', color: '#636363' }}>{prop.title}</p>
                                                                                        </div>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </>
                                                                    ) : ''}
                                                                </div>
                                                            </div>

                                                            <div ref={e => this.messagesContainer = e} className='' style={{ height: '100%' }}>

                                                                <div className='sc-1 d-flex flex-column' style={{ justifyContent: 'end', height: 'calc(100% - 46px)' }}>

                                                                    {(this.state.info?.body) ? (
                                                                        <div className="flexc mt-2 w-100" style={{ justifyContent: 'start', alignItems: 'end' }}>
                                                                            <div className="flexcc mx-2 " style={{ width: 30, height: 30, background: '#000', borderRadius: '50%', }}>
                                                                                <p className='' style={{ color: '#fff', fontSize: 15, fontWeight: '500' }}>
                                                                                    {this.state.info?.creator?.name ? this.state.info?.creator?.name?.substr(0, 1).toUpperCase() : ''}
                                                                                </p>
                                                                            </div>
                                                                            <div className="" >
                                                                                <p className="text-smallest text-uppercase px-2 text-bold" style={{ color: '#789' }}>{this.state.info?.creator?.name} - {moment(this.state.info?.cDate).format('MMM YYYY, DD')}</p>
                                                                                <div className="">
                                                                                    <div style={{ maxWidth: 207, }} className='my-1 px-1 py-1 ck-content-user'>
                                                                                        <div className="w-100 px-2">
                                                                                            <p style={{ fontSize: '13px', whiteSpace: 'break-spaces', wordBreak: 'break-all' }} className="" >{this.state.info?.body}</p>
                                                                                        </div>
                                                                                        <div className="w-100 flexc pt-2" style={{ justifyContent: 'end' }}>
                                                                                            <p className="text-smallest text-uppercase px-1 text-semibold" style={{ color: '#789' }}>{moment(this.state.info?.cDate).format('HH:mm')}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    ) : ''}
                                                                    {this.state.oneDataList?.map((prop, index) => {
                                                                        return (
                                                                            <div className="" key={prop._id}>
                                                                                {/* {console.log('prop == prop', this.state.oneDataList, prop, index)} */}
                                                                                <div className="flexc w-100" style={{ alignItems: 'end' }} key={prop._id}>

                                                                                    {prop.isAdminReply ? (
                                                                                        <div className="w-100">
                                                                                            <div className={" flexc w-100 " + (this.state.oneDataList[index - 1] ? (this.state.oneDataList[index - 1].isAdminReply == false ? 'mt-3' : '') : 'mt-3')} style={{ justifyContent: 'end', alignItems: 'end' }}>
                                                                                                <div className="d-flex flex-column mr-2" >
                                                                                                    {this.state.oneDataList[index - 1] ?
                                                                                                        (this.state.oneDataList[index - 1].isAdminReply == false && (
                                                                                                            <p className="text-smallest text-uppercase px-2 text-bold" style={{ color: '#789', textAlign: 'end' }}>antbuildz - {moment(prop?.cDate).format('MMM YYYY, DD')}</p>
                                                                                                        )) : (
                                                                                                            <p className="text-smallest text-uppercase px-2 text-bold" style={{ color: '#789', textAlign: 'end' }}>antbuildz - {moment(prop?.cDate).format('MMM YYYY, DD')}</p>
                                                                                                        )
                                                                                                    }
                                                                                                    {prop?.body ? (
                                                                                                        <div style={{ maxWidth: 207, borderBottomRightRadius: this.state.oneDataList[index + 1] ? (this.state.oneDataList[index + 1].isAdminReply == false ? '0px' : '5px') : '0px' }} className={' px-1 py-1 ck-content-admin ' + (this.state.oneDataList[index - 1] ? (this.state.oneDataList[index - 1].isAdminReply == false ? 'my-1' : 'mb-1') : 'my-1')}>
                                                                                                            {console.log('attachment55s', prop?.attachments)}
                                                                                                            {prop?.attachments && prop?.attachments?.map((attachment, index) => {
                                                                                                                console.log('attachment55', attachment)
                                                                                                                let format = attachment.split('.')[attachment.split('.').length - 1]
                                                                                                                let Component = tableComponents['FileInput']
                                                                                                                return (
                                                                                                                    <div className="flexcc w-100">
                                                                                                                        <a href={imageAddress(attachment)} target="_blank" className="mrd-1 mt-1" style={{}}>
                                                                                                                            {['jpg', 'jpeg', 'png'].includes(format) ?
                                                                                                                                <img style={{ width: 120, height: 70, objectFit: "cover", borderRadius: 10 }} src={imageAddress(attachment)} />
                                                                                                                                :
                                                                                                                                <Component data={attachment} header={this.state.attachmentsHeaders} />
                                                                                                                            }

                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                )
                                                                                                            })}
                                                                                                            <div className="w-100 px-2">
                                                                                                                <p style={{ fontSize: '13px', whiteSpace: 'break-spaces', wordBreak: 'break-all' }} className="d-flex ">{prop?.body?.trim()}</p>
                                                                                                            </div>
                                                                                                            <div className="w-100 flexc pt-2" style={{ justifyContent: 'end' }}>
                                                                                                                <p className="text-smallest text-uppercase px-1 text-semibold" style={{ color: '#789' }}>{moment(prop?.cDate).format('HH:mm')}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : (prop?.attachments &&
                                                                                                        <div style={{}} className="ck-content-admin p-1 my-1">
                                                                                                            {prop?.attachments?.map((attachment, index) => {
                                                                                                                console.log('attachment55', attachment)
                                                                                                                let format = attachment.split('.')[attachment.split('.').length - 1]
                                                                                                                let Component = tableComponents['FileInput']

                                                                                                                return (
                                                                                                                    <div style={{ alignItems: 'start' }} className="flexcc">
                                                                                                                        {/* <a href={contentUrl + attachment} target="_blank" className="mrd-1 mt-1" style={{}}> */}
                                                                                                                        <a href={imageAddress(attachment)} target="_blank" className="mt-1" style={{}}>
                                                                                                                            {/* <img stsyle={{ width: 60,height:60 ,objectFit:"cover" }} src={imageAddress(attachment)} /> */}
                                                                                                                            {
                                                                                                                                ['jpg', 'jpeg', 'png'].includes(format) ?
                                                                                                                                    <img style={{ width: 120, height: 70, objectFit: "cover", borderRadius: 10 }} src={imageAddress(attachment)} />
                                                                                                                                    :
                                                                                                                                    <Component data={attachment} header={this.state.attachmentsHeaders} />
                                                                                                                            }
                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                )
                                                                                                            })}
                                                                                                            {prop.body ? (<div></div>) : (
                                                                                                                <div className="w-100 flexc pt-2" style={{ justifyContent: 'end' }}>
                                                                                                                    <p className="text-smallest text-uppercase px-1 text-semibold" style={{ color: '#789' }}>{moment(prop?.cDate).format('HH:mm')}</p>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                                {this.state.oneDataList[index + 1] ?
                                                                                                    (this.state.oneDataList[index + 1].isAdminReply == false ?
                                                                                                        <img className="mr-2" style={{ width: '30px', height: '30px', borderRadius: '100%' }} src="/new/portrait.jpeg" />
                                                                                                        : <div className="mr-2" style={{ width: '30px', height: '30px', borderRadius: '100%' }}></div>
                                                                                                    ) : (
                                                                                                        <img className="mr-2" style={{ width: '30px', height: '30px', borderRadius: '100%' }} src="/new/portrait.jpeg" />

                                                                                                    )
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className={" flexc w-100 " + (this.state.oneDataList[index - 1] ? (this.state.oneDataList[index - 1].isAdminReply == true ? 'mt-3' : '') : 'mt-3')} style={{ justifyContent: 'start', alignItems: 'end' }}>
                                                                                            {/* {console.log('prop', prop)} */}
                                                                                            {this.state.oneDataList[index + 1] ?
                                                                                                (this.state.oneDataList[index + 1].isAdminReply == true ? (
                                                                                                    <div className="flexcc mx-2 " style={{ width: 30, height: 30, background: '#000', borderRadius: '50%', }}>
                                                                                                        <p className='' style={{ color: '#fff', fontSize: 15, fontWeight: '500' }}>
                                                                                                            {/* {this.props.user ? this.props.user.info.name?.substr(0, 1).toUpperCase() : ''} */}
                                                                                                            {this.state.info?.creator?.name ? this.state.info?.creator?.name?.substr(0, 1).toUpperCase() : ''}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="mx-2" style={{ width: '30px', height: '30px', borderRadius: '100%' }}></div>
                                                                                                )) : (
                                                                                                    <div className="flexcc mx-2 " style={{ width: 30, height: 30, background: '#000', borderRadius: '50%', }}>
                                                                                                        <p className='' style={{ color: '#fff', fontSize: 15, fontWeight: '500' }}>
                                                                                                            {/* {this.props.user ? this.props.user.info.name?.substr(0, 1).toUpperCase() : ''} */}
                                                                                                            {this.state.info?.creator?.name ? this.state.info?.creator?.name?.substr(0, 1).toUpperCase() : ''}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                )
                                                                                            }
                                                                                            < div className="">
                                                                                                {/* {console.log('parisa',this.state.info?.creator)} */}
                                                                                                {this.state.oneDataList[index - 1] ?
                                                                                                    (this.state.oneDataList[index - 1].isAdminReply == true && (
                                                                                                        <p className="text-smallest text-uppercase px-2 text-bold" style={{ color: '#789' }}>{this.state.info?.creator?.name} - {moment(prop?.cDate).format('MMM YYYY, DD')}</p>
                                                                                                    )) : (
                                                                                                        <p className="text-smallest text-uppercase px-2 text-bold" style={{ color: '#789' }}>{this.state.info?.creator?.name} - {moment(prop?.cDate).format('MMM YYYY, DD')}</p>
                                                                                                    )
                                                                                                }
                                                                                                <div className="">
                                                                                                    {prop?.body ? (
                                                                                                        <div style={{ maxWidth: 207, borderBottomLeftRadius: this.state.oneDataList[index + 1] ? (this.state.oneDataList[index + 1].isAdminReply == true ? '0px' : '5px') : '0px' }} className={' px-1 py-1 ck-content-user ' + (this.state.oneDataList[index - 1] ? (this.state.oneDataList[index - 1].isAdminReply == true ? 'my-1' : 'mb-1') : 'my-1')}>
                                                                                                            {/* <p style={{ fontSize: '13px' }} className="" ></p> */}
                                                                                                            {prop?.attachments &&
                                                                                                                prop?.attachments?.map((attachment, index) => {
                                                                                                                    let format = attachment.split('.')[attachment.split('.').length - 1]
                                                                                                                    let Component = tableComponents['FileInput']
                                                                                                                    return (
                                                                                                                        <div style={{}} className="">
                                                                                                                            {/* <a href={contentUrl + attachment} target="_blank" className="mrd-1 mt-1" style={{}}> */}
                                                                                                                            <a href={imageAddress(attachment)} target="_blank" className="mrd-1 mt-1" style={{}}>
                                                                                                                                {/* <img style={{ width: 60,height:60 ,objectFit:"cover" }} src={imageAddress(attachment)} /> */}
                                                                                                                                {['jpg', 'jpeg', 'png'].includes(format) ?
                                                                                                                                    <img style={{ width: 120, height: 70, objectFit: "cover", borderRadius: 10 }} src={imageAddress(attachment)} />
                                                                                                                                    :
                                                                                                                                    <Component data={attachment} header={this.state.attachmentsHeaders} />
                                                                                                                                }
                                                                                                                            </a>
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                })}
                                                                                                            <div className="w-100 px-2">
                                                                                                                <p style={{ fontSize: '13px', whiteSpace: 'break-spaces', wordBreak: 'break-all' }} className="" >{prop?.body?.trim()}</p>
                                                                                                            </div>
                                                                                                            <div className="w-100 flexc pt-2" style={{ justifyContent: 'end' }}>
                                                                                                                <p className="text-smallest text-uppercase px-1 text-semibold" style={{ color: '#789' }}>{moment(prop?.cDate).format('HH:mm')}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        prop?.attachments &&
                                                                                                        <div style={{ background: "#f6f6f6", borderRadius: 5, }} className="p-1 my-1">
                                                                                                            {prop?.attachments?.map((attachment, index) => {
                                                                                                                console.log('attachment55', attachment)
                                                                                                                let format = attachment.split('.')[attachment.split('.').length - 1]
                                                                                                                let Component = tableComponents['FileInput']
                                                                                                                return (
                                                                                                                    <div style={{}} className="">
                                                                                                                        {/* <a href={contentUrl + attachment} target="_blank" className="mrd-1 mt-1" style={{}}> */}
                                                                                                                        <a href={imageAddress(attachment)} target="_blank" className="mt-1" style={{}}>
                                                                                                                            {/* <img style={{ width: 60,height:60 ,objectFit:"cover" }} src={imageAddress(attachment)} /> */}
                                                                                                                            {['jpg', 'jpeg', 'png'].includes(format) ?
                                                                                                                                <img style={{ width: 120, height: 70, objectFit: "cover", borderRadius: 10 }} src={imageAddress(attachment)} />
                                                                                                                                :
                                                                                                                                <Component data={attachment} header={this.state.attachmentsHeaders} />
                                                                                                                            }
                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                )
                                                                                                            })}
                                                                                                            {prop.body ? (<div></div>) : (

                                                                                                                <div className="w-100 flexc pt-2" style={{ justifyContent: 'end' }}>
                                                                                                                    <p className="text-smallest text-uppercase px-1 text-semibold" style={{ color: '#789' }}>{moment(prop?.cDate).format('HH:mm')}</p>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>

                                                                                    )}
                                                                                </div>

                                                                                {/* <div>

                                                                                <div className="ticketBox  ">
                                                                                    <div className='ck-content'>
                                                                                    <div style={{ border: '1px solid #EDE4FF', borderRadius: '20px', backgroundColor: '#F6F6F6', width: 'max-content' }} className='my-1 px-3 py-1 ck-content'>
                                                                                        <p className="chatbox-desc" dangerouslySetInnerHTML={{ __html: prop?.body }}></p>
                                                                                    </div>
                                                                                    </div>
                                                                                    <div className="flexc flex-wrap ">
                                                                                    {prop?.attachments && prop?.attachments.map((attachment, index) => {
                                                                                        return (
                                                                                        <a href={imageAddress(attachment)} target="_blank" className="mrd-1 mt-1">
                                                                                            <div className="flexc" style={{ backgroundColor: '#00000010', borderRadius: 4, padding: '2px 5px' }}>
                                                                                            <div className="flexcc">
                                                                                                <img src="/new/attach-filee.png" height={12} />
                                                                                            </div>
                                                                                            <p className="text-smaller mx-1">{attachment.extension} Attechment</p>
                                                                                            </div>
                                                                                        </a>
                                                                                        )
                                                                                    })}
                                                                                    </div>
                                                                                </div>
                                                                            </div> */}
                                                                            </div>

                                                                        )
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className=' w-100 ' style={{ background: "#f3f3f3", position: "sticky", bottom: 0, left: 0, WebkitBackdropFilter: 'blur(20px)', backdropFilter: 'blur(20px)', zIndex: 1, }}>
                                                            {this.state.attachments && (
                                                                <div className='sc-1' style={{ position: 'absolute', bottom: 61, maxHeight: 200, minWidth: 250, overflowY: 'scroll', background: "#efefef", borderRadius: 5 }}>
                                                                    {this.state.attachments['**files']?.attachments?.map((prop, index) => {
                                                                        return (
                                                                            <div className='flexc px-3 py-2' style={{ borderBottom: '1px solid #ddd', }}>
                                                                                {/* {console.log("this.state.attachments['**files'].attachments[0]",this.state.attachments['**files'].attachments[0])} */}
                                                                                <div onClick={() => { this.removeFile("key", index) }} style={{ backgroundColor: '#ee5050dd', borderRadius: '50%', width: 18, height: 18, display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 0, cursor: 'pointer' }}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" style={{ width: 15 }} >
                                                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                                                    </svg>
                                                                                </div>

                                                                                <div className='flexcc ml-2 mr-1' style={{ width: 18, height: 18 }}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#434343" class="w-6 h-6">
                                                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                                                                    </svg>
                                                                                </div>

                                                                                {/* <p style={{ fontSize: '12px' }}>{this.state.attachments['**files'].attachments[index].name}</p> */}
                                                                                <p style={{ fontSize: '12px' }}>{prop.name}</p>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )}
                                                            {this.props?.page?.cantSendMsg != -1 && (


                                                                <div className='px-2 pb-3 pt-3 flexcb' style={{ height: 58 }}>
                                                                    <div className='flexcc cursor-pointer' style={{ background: "#fff", borderRadius: 50, height: 40, width: 40 }} onClick={() => this.showAttachments()}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#6e7a85" style={{ width: 40, height: 20 }}>
                                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                                                                        </svg>
                                                                    </div>
                                                                    <div className=' w-100 px-2' >
                                                                        <div style={{ background: '#fff', borderRadius: 5 }}>

                                                                            <textarea ref={el => this.input = el} rows={1} value={this.state.text} onChange={(e) => this.updateInput(e.target)} className="w-100 mt-0 sc-1" style={{ padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, maxHeight: 37, overflow: 'auto' }} placeholder="Message ..." />

                                                                            {/* <FormViewer ref={el => this.form = el} headers={this.state.header} inputClass={"modern-input-ticketing"} /> */}
                                                                        </div>
                                                                    </div>
                                                                    <div className='flexcc cursor-pointer' style={{ background: "#fff", borderRadius: 50, height: 40, width: 40 }} onClick={() => this.postReply()}>
                                                                        {this.state.isLoadingPostReply ? (
                                                                            <Loader
                                                                                type={"Oval"}
                                                                                color={"#202020"}
                                                                                height={20}
                                                                                width={40}
                                                                            />
                                                                        ) : (

                                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#6e7a85" style={{ width: 40, height: 20 }}>
                                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                                                                            </svg>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                            }
                                                        </div>
                                                        {/* <textarea ref={el => this.input = el} rows={1} value={this.state.text} onChange={(e) => this.updateInput(e.target)} className="w-full mt-0" style={{ padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: 'inherit', minHeight: 37, maxHeight: 100, }} placeholder="Message ..." /> */}

                                                    </div>
                                                    {/* <MessengerAttachments ref={el => this.MessengerAttachments = el} height='100%' passAttachFiles={this.passAttachFiles} />
                                                                        <MessengerDropModal ref={el => this.MessengerDropModal = el} height='100%' sendFileMessage={this.sendFileMessage} /> */}
                                                    <div className="col-md-12 col-lg-4 p-0 order-1 order-lg-2 d-none d-lg-block" style={{}}>

                                                        <div className='h-100 sc-1' style={{ backgroundColor: '#fff', position: 'fixed' }}>
                                                            <div style={{}} className=" py-1 w-100 ">
                                                                {/* <Collapsible open={!this.state.showList}> */}
                                                                <div className="ticketing-information px-2 ">
                                                                    <div className='mt-2 ticketing-priority'>
                                                                        {/* {console.log('ridix', item)} */}
                                                                        <div className='' style={{ position: 'relative' }}>
                                                                            {/* <img className=' ' style={{ objectFit: 'contain', borderRadius: '5px', width: 250, height: 241, background: '#efefef' }} src={contentUrl + 'thumb-' + this.state.data[this.state.ticketingSelect].equipment?.image[0]} /> */}
                                                                            <img className=' ' style={{ objectFit: 'cover', borderRadius: '5px', width: "100%", aspectRatio: '1 / 1' }} src={imageAddress(this.state.data[this.state.ticketingSelect]?.equipment?.image)} />
                                                                            <div className='flexcc' style={{ position: 'absolute', top: 0, right: 2, margin: 3, padding: '3px 4px', background: '#ffffffcc', borderRadius: 5 }}>
                                                                                <img style={{ width: '20px,', height: '20px' }} src={this.getStatusInfo(this.state.data[this.state.ticketingSelect]?.status) != '-1' ? this.getStatusInfo(this.state.data[this.state.ticketingSelect]?.status)?.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" />
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div className="ticket-situation flexcc" style={{}}>
                                                                                {/* {console.log('this.state.info?', this.state.info, 'dsd', this.state.data, 'this.state.ticketingSelect', this.state.ticketingSelect)} */}
                                                                                {/* {console.log('this.state.data[this.state.ticketingSelect]).status?.color', this.state.data[this.state.ticketingSelect].status?.color)} */}
                                                                                {/* <img style={{ width: '20px,', height: '20px', position: 'absolute', top: 20 }} src={this.state.data[this.state.ticketingSelect].status != '-1' ? this.getStatusInfo(this.state.data[this.state.ticketingSelect]).status?.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" /> */}
                                                                                {/* <img style={{ width: '20px,', height: '20px',position:'absolute',top:20 }} src={this.state.info?.status != '-1' ? this.getStatusInfo(this.state.data[this.state.ticketingSelect]).status?.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" /> */}
                                                                                <div className="ticket-situation flexcc" style={{}}>
                                                                                    {/* <img style={{ width: '20px,', height: '20px' }} src={item.status != '-1' ? status.color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" /> */}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <p className='ticketing-priority  flexcb' style={{ fontSize: '15px', fontWeight: 600 }}>{this.state.data[this.state.ticketingSelect]?.equipment?.title}</p>
                                                                    {/* {console.log('firstttt', this.state.data[this.state.ticketingSelect].equipment)} */}
                                                                    <div className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Brand')}
                                                                        <span className='' style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.brand?.name}</span>
                                                                    </div>
                                                                    <div className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Model')}
                                                                        <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.model}</span>
                                                                    </div>
                                                                    <p className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Manufacture Year')}
                                                                        <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.year}</span>
                                                                    </p>
                                                                    <p className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Equipment Id')}
                                                                        <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.tequipmentId}</span>
                                                                    </p>
                                                                    <p className='' style={{ fontWeight: '600', fontSize: 18 }}>
                                                                        {/* {console.log('this.state.data[this.state.ticketingSelect].equipment',)} */}
                                                                        {/* <p style={{marginTop: 4, paddingBottom: 4, fontWeight: '700', fontSize: '13px', color: '#111' }}><span className=" mr-1" style={{ fontWeight: 'bold', color: '#111', fontSize: 13, marginBottom: 2, borderBottom: "0px solid #f2f6f8", marginTop: 4, paddingBottom: 4 }}>{this.props.products.country?.currency ?? 'S$'}</span>{priceStandardView(String(this.props.products?.price))}</p> */}
                                                                        {/* <p style={{ fontSize: 16, fontWeight: '500', color: '#000', marginBottom: 0 }}>{this.props.products?.country?.currency ?? this.props.cart.items[0]?.data.country?.currency ?? 'S$'}{priceStandardView(String(this.props.products?.price))}<span style={{ fontSize: 11 }}>/Total</span></p> */}
                                                                        {/* <p style={{ fontWeight: '700', fontSize: '11px', color: '#111' }}><span className="mr-1" style={{ fontWeight: 'bold', color: '#111', fontSize: 11, marginBottom: 2, borderBottom: "0px solid #f2f6f8", marginTop: 4, paddingBottom: 4 }}>USD</span>{
                                              priceStandardView((this.props.products?.price * ((100 - this.props.products?.category[this.props.products?.category.length - 1]?.discount) / 100) * .73281547).toFixed(0))

                                          }</p> */}
                                                                    </p>
                                                                    <div className='' style={{ borderTop: '1px solid #efefef' }}></div>
                                                                    <div className="  ticketing-priority  mx-2 mt-2 flexc">
                                                                        <p className="" style={{ color: '#333', fontSize: '13px', fontWeight: 700 }}>User</p>
                                                                        <p className="ticketing-duedate-date1 mld-4" style={{ color: '#333', fontSize: '13px', fontWeight: 500 }}> {this.state.info?.creator?.name} </p>
                                                                    </div>
                                                                    <div className=" ticketing-priority flexc  mx-2 mt-2">
                                                                        <p style={{ color: '#333', fontSize: '13px', fontWeight: 700 }} className="">Status</p>
                                                                        <p className="ticketing-duedate-date1 mld-4" style={{ color: this.getStatusInfo(this.state.info?.status).color, fontSize: '13px' }}>{checkTranslation(this.getStatusInfo(this.state.info?.status).label)}</p>
                                                                    </div>
                                                                    <div className="ticketing-priority flexc  mx-2 mt-2">
                                                                        <p style={{ color: '#333', fontSize: '13px', fontWeight: 700 }} className="ticketing-side-info">Create Date</p>
                                                                        <p style={{ color: '#777', fontSize: '13px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.cDate).format("MMM YYYY, DD (HH:mm)")}</p>
                                                                    </div>

                                                                    <div className="ticketing-priority flexc mx-2 mt-2">
                                                                        <p style={{ color: '#333', fontSize: '13px', fontWeight: 700 }} className="ticketing-side-info">Last Update</p>
                                                                        <p style={{ color: '#777', fontSize: '13px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.uDate).format("MMM YYYY, DD (HH:mm)")}</p>
                                                                    </div>

                                                                    <div className=" mt-2">
                                                                        <a target="_blank" href={"https://antbuildz.com/buy/equipment/" + this.state.data[this.state.ticketingSelect]?.equipment?._id} className='m-2' style={{ color: '#677dc4', fontSize: '12px', fontWeight: 700 }}>
                                                                            View Equipment on website
                                                                        </a>
                                                                    </div>

                                                                    {this.props.page?.key != 'recyclebin' ? (
                                                                        <>
                                                                            {this.props.page?.cantSendMsg != -1 && (

                                                                                <button className="mt-2  mx-2" onClick={() => this.sumbitModal.showModal()} style={{ background: '#677dc4', borderRadius: 8 }}>
                                                                                    <p className="px-3 py-2" style={{ color: "#fff" }}>Convert to order</p>
                                                                                </button>
                                                                            )}

                                                                            <button className="mt-2  mx-2" onClick={() => this.openRemoveModal()} style={{ background: '#677dc4', borderRadius: 8 }}>
                                                                                <p className="px-3 py-2" style={{ color: "#fff" }}>Move To Recycle Bin</p>
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <button className="mt-2  mx-2" onClick={() => this.openRemoveModal()} style={{ background: '#677dc4', borderRadius: 8 }}>
                                                                            <p className="px-3 py-2" style={{ color: "#fff" }}>Restore</p>
                                                                        </button>

                                                                    )}




                                                                </div>





                                                                {/* </Collapsible> */}


                                                                {this.state.width < 992 && (
                                                                    <p onClick={() => this.setState({ showList: !this.state.showList })} className="collaps-p py-2 px-0 m-0" style={{ color: '#007aff', cursor: 'pointer' }}>{this.state.showList ? "Hide" : "Show"} information</p>
                                                                )}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}

                                </div>

                            )}



                        </div>





                    </div>
                </Configurer >


                {/* <Modal ref={el => this.infoModal = el} maxWidth={500}>
                    {(this.state.ticketingSelect != null && this.state.ticketingSelect != undefined) && (
                        <div style={{ backgroundColor: '#fff', borderRadius: 12, padding: 0, }}>
                            <div className="" style={{}}>
                                <div className='h-100 sc-1' style={{ backgroundColor: '#fff', overflow: 'auto' }}>
                                    <div style={{}} className="w-100 ">
                                        <Collapsible open={!this.state.showList}>
                                            <div className="ticketing-information ">
                                                <div className=' ticketing-priority' style={{ padding: 0 }}>
                                                    {console.log('ridix', this.state.data[this.state.ticketingSelect])}
                                                    <div className='' style={{ position: 'relative' }}>
                                                        {/* <img className='w-100 ' style={{ height: 'auto', objectFit: 'cover', borderRadius: '5px' }} src={imageAddress(this.state.data[this.state?.ticketingSelect]?.equipment?.image)} /> *
                                                        <div className='' style={{ position: 'absolute', top: 0, right: 0, margin: 3, padding: '3px 4px', background: '#ffffffcc', borderRadius: 5 }}>
                                                            {/* <img style={{ width: '20px,', height: '20px' }} src={this.getStatusInfo(this.state.data[this.state.ticketingSelect].status) != '-1' ? this.getStatusInfo(this.state.data[this.state.ticketingSelect].status).color == '#EE5050' ? '/new/clock.png' : '/new/clock(1).png' : '/new/flag.png'} className="ticket-img1" /> *
                                                        </div>
                                                    </div>

                                                </div>

                                                <p className='ticketing-priority my-3 flexcb' style={{ fontSize: '15px', fontWeight: 600 }}>{this.state.data[this.state.ticketingSelect]?.equipment?.title}</p>
                                                {console.log('firstttt', this.state.data[this.state.ticketingSelect].equipment)}
                                                <div className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Brand')}
                                                    <span className='' style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.brand?.name}</span>
                                                </div>
                                                <div className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Model')}
                                                    <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.model}</span>
                                                </div>
                                                <p className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Manufacture Year')}
                                                    <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.year}</span>
                                                </p>
                                                <p className='m-2' style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>{translate('Equipment Id')}
                                                    <span style={{ fontSize: 13, color: '#636363', fontWeight: '400', borderRadius: 4 }}>: {this.state.data[this.state.ticketingSelect]?.equipment?.tequipmentId}</span>
                                                </p>

                                                <div className='' style={{ border: '1px solid #efefef' }}></div>
                                                <div className="  ticketing-priority my-3 flexcb">
                                                    <p className="" style={{ color: '#333', fontSize: '12px', fontWeight: 700 }}>User</p>
                                                    <p className="ticketing-duedate-date1 mld-4" style={{ color: '#333', fontSize: '11px', fontWeight: 500 }}> {this.state.info?.creator?.name} </p>
                                                </div>
                                                <div className=" ticketing-priority mt-2">
                                                    <p style={{ color: '#333', fontSize: '12px', fontWeight: 700 }} className="">Status</p>
                                                    <p className="ticketing-duedate-date1 mld-4" style={{ color: this.getStatusInfo(this.state.info?.status).color, fontSize: '12px' }}>{checkTranslation(this.getStatusInfo(this.state.info?.status).label)}</p>
                                                </div>
                                                <div className="ticketing-priority my-3">
                                                    <p style={{ color: '#333', fontSize: '11px', fontWeight: 700 }} className="ticketing-side-info">Create Date</p>
                                                    <p style={{ color: '#777', fontSize: '11px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.cDate).format("MMM YYYY, DD (HH:mm)")}</p>
                                                </div>

                                                <div className="ticketing-priority">
                                                    <p style={{ color: '#333', fontSize: '11px', fontWeight: 700 }} className="ticketing-side-info">Last Update</p>
                                                    <p style={{ color: '#777', fontSize: '11px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.uDate).format("MMM YYYY, DD (HH:mm)")}</p>
                                                </div>

                                                <div className=' ticketing-priority'>
                                                    <div className='flexc'>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className='' style={{ borderBottoml: '1px solid #ddd' }}>

                                            </div>

                                            <div className="px-1 mt-1 flexc">



                                            </div>

                                            <Collapsible open={this.state.showChangeStatus}>
                                                <div className="mt-2 px-2">
                                                    <div className="py-2 px-2" style={{ backgroundColor: '#f2f6f8', color: '#000', borderRadius: 4, fontSize: 14 }}>
                                                        <p className='px-2'>Are You sure you want to close this ticket?</p>
                                                        <button onClick={() => this.updateStatus()} className="px-1 mt-2 py-2 text-center mx-1 w-100" style={{ backgroundColor: '#ee5050', color: '#fff', borderRadius: 4 }}>
                                                            <p className="text-smaller text-bold">Yes, Close Ticket</p>
                                                        </button>

                                                    </div>
                                                </div>
                                            </Collapsible>



                                            <Collapsible open={this.state.showRemoveTicket}>
                                                <div className="mt-2 px-2">
                                                    <div className="py-2 px-2" style={{ backgroundColor: '#f2f6f8', color: '#000', borderRadius: 4, fontSize: 14 }}>
                                                        <p>Are You sure you want to remove this ticket?</p>

                                                        <button onClick={() => this.fetchRemove()} className="px-1 py-2 text-center mx-1 w-100" style={{ backgroundColor: '#ee5050', color: '#fff', borderRadius: 4 }}>
                                                            <p className="text-smaller text-bold">Yes, Remove Ticket</p>
                                                        </button>

                                                    </div>
                                                </div>
                                            </Collapsible>


                                        </Collapsible>
                                        {console.log('88888888888', this.state.data)}
                                        {/* <Link href={{ pathname: `/trading/equipment/` + this.state.data.equipment?._id }}> *
                                        <Link href={{ pathname: `/trading/equipment/` + this.state.info?.equipment?._id }}>

                                            <p className="collaps-p py-2 px-0 m-0" style={{ color: '#007aff', cursor: 'pointer' }}>More info</p>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        </div>

                    )}

                </Modal> */}


                < FilterModal
                    ref={el => this.filterModal = el}
                    initData={this.state.filter}
                    page={this.props.page}
                    headers={this.props.page?.headers}
                    doFilter={this.doFilter} />


                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.page}
                    headers={this.props.page?.headers}
                    initData={this.state.currentItem}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    width={this.props.page?.modalWidth}
                    submitForm={this.props.page?.onSubmit ? this[this.props.page?.onSubmit] : null}
                    showDates={true}
                />


                <RemoveModal
                    isLoading={this.state.isLoadingRemove}
                    removeFunction={this.fetchRemove}
                    ref={el => this.removeModal = el}
                />


                <WikiAskModal
                    isLoading={this.state.isLoadingLeave}
                    confirmed={this.submitWikiChanges}
                    ref={el => this.wikiAksModal = el}
                    title={"Change Things"}
                    option={'Change Things'}
                    description={"Do You want to update related things to this wiki?"}
                />

                <OptionsListModal ref={el => this.optionsModal = el}
                    options={this.state.options}
                />



                <Modal className="p-5" ref={el => this.modalI = el} maxWidth={300} >
                    {/* <Collapsible open={this.state.showList || this.state.width > 991}> */}
                    <div className="p-2" style={{ backgroundColor: '#fff', borderRadius: '10px' }}>
                        <div style={{}} className="ticketing-information px-2">

                            <p className="text-smallest text-uppercase text-bold" style={{ color: '#789' }}>{this.state.info?.creator?.name} - {moment(this.state.info?.cDate).format('MMM YYYY, DD HH:mm')}</p>


                            <div style={{}} className="flexcb mt-3">
                                <p style={{ fontSize: '13px', fontWeight: 600 }} className="">Status</p>
                                <p className="ticketing-duedate-date1 mld-4" style={{ color: this.getStatusInfo(this.state.info?.status).color, fontSize: '12px' }}>{checkTranslation(this.getStatusInfo(this.state.info?.status).label)}</p>
                            </div>

                            <div style={{}} className="flexcb my-3">
                                <p style={{ color: '#333', fontSize: '11px', fontWeight: 700 }} className="ticketing-side-info">Create Date</p>
                                {/* <div style={{borderRight:'1px solid #333', width:'1px', height:'20px'}}></div> */}
                                <p style={{ color: '#777', fontSize: '11px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.cDate).format("MMM YYYY, DD (HH:mm)")}</p>
                            </div>

                            <div className="flexcb">
                                <p style={{ color: '#333', fontSize: '11px', fontWeight: 700 }} className="ticketing-side-info">Last Update</p>
                                {/* <div style={{borderRight:'1px solid #333', width:'1px', height:'20px'}}></div> */}
                                <p style={{ color: '#777', fontSize: '11px', fontWeight: 500 }} className="ticketing-duedate-date1 mld-4 text-end">{moment(this.state.info?.uDate).format("MMM YYYY, DD (HH:mm)")}</p>
                            </div>


                            {/* <div className=" ticketing-reporter">
                                                        <p className=" ticketing-side-info">User Phone</p>
                                                        <p className="ticketing-reporter-desc2">{this.state.info?.creator?.phone}</p>
                                                    </div> */}



                            {/* <div className="px-1 pb-2">
                                                        <button className="ticketing-learnmore-button">Show More</button>
                                                    </div> */}
                        </div>
                        <div className="px-1 my-2 flexc">

                            {/* <button onClick={() => this.setState({ showChangeStatus: !this.state.showChangeStatus })} className="px-1 py-2 text-center mx-1 w-100" style={{ backgroundColor: '#007aff', color: '#fff', borderRadius: 4 }}>
                                                                    <p className="text-smaller text-bold">Change Status</p>

                                                                </button> */}
                            {this.state.currentTab == 'User' && (

                                <button onClick={() => this.handleModal()} className="px-1 py-2 text-center my-2 mx-1 w-100" style={{ backgroundColor: '#FFCF21', color: '#333', borderRadius: 4 }}>
                                    <p className="text-smaller text-bold">Change Status</p>

                                </button>
                            )}


                        </div>


                        <div className="m-2">
                            {this.state?.info?.equipment && (
                                <div className="flexc">
                                    <img className="mr-2" style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '5px' }} src={'https://cdn2.antbuildz.com/images/' + 'thumb-' + this.state.info.equipment?.image[0]} />
                                    <div className="flex">
                                        <p className="" style={{ fontSize: '15px', color: '#333', fontWeight: 500 }}>{this.state.info.equipment.title}</p>
                                        <p className="" style={{ fontSize: '12px', color: '#333' }}>{this.state.info.equipment.price}</p>
                                        {this.state.info.equipment.description && (
                                            <p className="" style={{ fontSize: '12px', color: '#333' }}>{this.state.info.equipment.description}</p>
                                        )}
                                        {this.state.info.equipment.model && (
                                            <p className="" style={{ fontSize: '12px', color: '#333' }}>{this.state.info.equipment.model}</p>
                                        )}

                                    </div>
                                </div>
                            )}
                        </div>

                        <Collapsible open={this.state.showRemoveTicket}>
                            <div className="mt-2 px-2">
                                <div className="py-2 px-2" style={{ backgroundColor: '#f2f6f8', color: '#000', borderRadius: 4, fontSize: 14 }}>
                                    <p>Are You sure you want to remove this ticket?</p>

                                    <button onClick={() => this.fetchRemove()} className="px-1 py-2 text-center my-2 mx-1 w-100" style={{ backgroundColor: '#ee5050', color: '#fff', borderRadius: 4 }}>
                                        <p className="text-smaller text-bold">Yes, Remove Ticket</p>
                                    </button>

                                </div>
                            </div>
                        </Collapsible>


                        {/* </Collapsible> */}
                    </div>
                </Modal>

                <Modal ref={el => this.attachments = el} maxWidth={500}>
                    <div className="py-3 px-4" style={{ backgroundColor: '#fff', borderRadius: 12, padding: 0, }}>
                        <div className='pb-5' style={{ backgroundColor: '#fff', }}>
                            <p style={{ color: '#000', fontWeight: 500, fontSize: '20px' }}>Upload File</p>
                            <p style={{ color: '#789', fontSize: 12 }}>You can attach the file you need here</p>
                        </div>
                        <FormViewer ref={el => this.attachmentsForm = el} headers={this.state.attachmentsHeaders} initData={this.state.attachments} noPadding={true} inputClass={"modern-input"} />
                        <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                            <button className='py-2 px-4' style={{ backgroundColor: "#e3180a", borderRadius: '5px', color: '#fff', }} onClick={() => this.getFile()}>
                                <p>Submit</p>
                            </button>
                        </div>
                    </div>
                </Modal>
                <Modal ref={el => this.sumbitModal = el} maxWidth={500}>
                    <div className="py-3 px-4" style={{ backgroundColor: '#fff', borderRadius: 12, padding: 0, }}>
                        <p className="mb-3" style={{ color: '#000', fontWeight: 500, fontSize: '20px' }}>Convert to order</p>

                        {/* <FormViewer ref={el => this.ConvertOrder = el} headers={this.state.headd} noPadding={true} inputClass={"modern-input"} /> */}
                        <FormViewer ref={el => this.ConvertOrder = el} headers={this.state.headd} errors={this.state.errors} inputClass={'modern-input'} />

                        <div className="mt-3" style={{ justifyContent: 'flex-end', display: 'flex' }}>
                            <button className='py-2 px-4' style={{ backgroundColor: "#e3180a", borderRadius: '5px', color: '#fff', }} onClick={() => this.ConvertToOrder()}>
                                <p>Submit</p>
                            </button>
                        </div>
                    </div>
                </Modal>

                {/* <Modal ref={el => this.removeModal = el} maxWidth={500}>
                    <div className="py-3 px-4" style={{ backgroundColor: '#fff', borderRadius: 12, padding: 0, }}>
                        <p className="mb-3" style={{ color: '#000', fontWeight: 500, fontSize: '20px' }}>Move To Recycle Bin</p>

                        <p className="mb-3" style={{ color: '#000', fontWeight: 400, fontSize: '14px' }}>Are You Sure You Want To Move This Chat To Recycle Bin</p>

                        <div className="mt-3" style={{ justifyContent: 'flex-end', display: 'flex' }}>
                            <button className='py-2 px-4' style={{ backgroundColor: "#e3180a", borderRadius: '5px', color: '#fff', }} onClick={() => this.fetchRemove()}>
                                <p>Submit</p>
                            </button>
                        </div>
                    </div>
                </Modal> */}

                <Modal className="p-5" ref={el => this.modal = el} maxWidth={300} >
                    <div className="px-2 mr-4" style={{ background: '#fff', borderRadius: '10px' }}>
                        {/* <div className="mt-2 px-2">
                            <div className="py-2 px-2" style={{ backgroundColor: '#f2f6f8', color: 'black', borderRadius: 4 }}>
                                <SelectInput data={this.state.info?.status} changeValue={this.updateStatus} header={{ key: 'status', information: { type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], } }} />
                            </div>
                        </div> */}
                        <p className="p-2 ml-2" style={{ fontSize: '15px', borderBottom: '1px solid #FFCF21', width: '90%', fontWeight: 500 }}><span>Status :  </span>{this.state.status?.title ?? checkTranslation(this.getStatusInfo(this.state.info?.status).label)}</p>
                        <div className=" mt-1 mb-1" style={{}}>
                            {this.state.statuselist.map((item, index) => {
                                // console.log('aaaaaaaaaa',this.state.info?.status,item)
                                return (
                                    <>
                                        <p onClick={() => this.setState({ status: item })} className="p-2 ml-2 mr-2 " style={this.state.status ? this.state.status.value == item.value ? { color: '#000', cursor: 'pointer', fontSize: '14px', fontWeight: 500, backgroundColor: '#FDFFAE', borderRadius: '50px' } : { cursor: 'pointer', fontSize: '14px', backgroundColor: '#fff' } : this.state.info?.status == item.value ? { color: '#000', cursor: 'pointer', fontSize: '14px', backgroundColor: '#FDFFAE', borderRadius: '50px' } : { cursor: 'pointer', fontSize: '14px', backgroundColor: '#fff' }}>{item.title}</p>
                                    </>
                                )
                            })}
                        </div>
                        <div className="" style={{ justifyContent: 'end', display: 'flex' }}>
                            <button onClick={() => this.updateStatus(this.state.status?.value)} className="px-3 py-2 mb-3 mr-3" style={{ color: '#000', backgroundColor: '#FFCF21', borderRadius: 5, fontSize: '13px', justifyContent: 'end', cursor: 'pointer', fontWeight: 500 }}>
                                submit
                            </button>
                        </div>
                    </div>
                </Modal>
                <Modal ref={el => this.exportModal = el} maxWidth={300}>
                    <div className="pb-5 w-100 h-100">
                        <div className="w-100 h-100" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                            <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

                                <p className="text-bold mb-0 text-normal ">Export</p>

                                <div className="cursor-pointer" onClick={() => this.optionsModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>
                            <div className="py-4 px-3 pb-2 w-100 text-center">
                                <Loader
                                    type="Oval"
                                    color="#789"
                                    height="50"
                                    width="50"
                                />
                                <p>Exporting in process ...</p>
                                <p className="text-smaller" style={{ color: '#789' }}>Wait till it is completed</p>

                            </div>

                        </div>
                    </div>

                </Modal>

            </>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, tickets: state.tickets })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminListApplet);
